import React from 'react'
import Start from '../ui/Start/Start';

const StartInterviewLayout = ({type}) => {
  return (
    <Start title={`${type} Interview`} url={`/quiz/${type}`}/>
  )
}

export default StartInterviewLayout